import React from 'react'

import { APIURL } from '../constants'
import services from '../components/services'
import DefaultLayout from '../components/layouts/DefaultLayout'
import { LegalDisplay } from '../components/home/legal'

const Privacy = (props) => (
  <LegalDisplay {...props} />
)

Privacy.Layout = DefaultLayout

export async function getServerSideProps(ctx) {
  const { host } = ctx.req.headers
  const res = await services.get_v2(APIURL.API_LEGAL('privacy'), {}, host)
  if (res.statusCode !== 200) {
    return {
      notFound: true
    }
  }
  return {
    props: {
      title: 'Privacy Policy',
      content: res.response
    }
  }
}

export default Privacy
